import { ChakraFlex, ChakraText } from '@equip.health/ui';

export const PatientHeaderAvatarFallBackIcon = ({
  patientFullName,
  fontSize = 'lg',
}: {
  patientFullName: string;
  fontSize?: 'lg' | 'sm';
}) => (
  <ChakraFlex alignItems="center" justifyContent="center">
    <ChakraText fontSize={fontSize}>
      {patientFullName
        .replace('"', '')
        .split(' ')
        .map((name: string) => name?.[0]?.toUpperCase() ?? '')
        .join('')}
    </ChakraText>
  </ChakraFlex>
);
